import './TimeTargetProgress.css';

import React from 'react';
import { generateClassName } from '../../../b2b-common/helpers';
import { LinearProgress } from '@mui/material';
import { AdsClick, DateRange } from '@mui/icons-material';
import { getIconWithTooltip } from '../helper';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const TimeTargetProgress = ({ targetProgress = 0, timeProgress = 0,
    showCalendarProgress = true, showTargetProgress = true,
    className = null }) => {
    const { t } = useB2BTranslation('b2b-plans');

    return (
        <div className={generateClassName('time-target-progress', '-container', className)}>
            {showTargetProgress && (
                <LinearProgress variant='determinate' value={Math.min(100, targetProgress)} className={generateClassName('time-target-progress', '-target-linear-progress', className)} />
            )}
            {showCalendarProgress && (
                <LinearProgress variant='determinate' value={timeProgress} className={generateClassName('time-target-progress', '-time-linear-progress', className)} />
            )}
            {showTargetProgress && (
                <div className={generateClassName('time-target-progress', '-target-value', className)}>
                    {getIconWithTooltip(AdsClick, {}, t('Target Progress'))} {targetProgress} %
                </div>
            )}
            {showCalendarProgress && (
                <div className={generateClassName('time-target-progress', '-time-value', className)}>
                    {getIconWithTooltip(DateRange, {}, t('Calendar Progress'))} {timeProgress} %
                </div>
            )}
        </div>
    );
};

export default TimeTargetProgress;